import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "videos-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = { class: "nav-card" }
const _hoisted_5 = { class: "nav-logo" }
const _hoisted_6 = { class: "logo-icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "nav-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "nav-menu-visual",
  "aria-hidden": "true"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "page-shell" }
const _hoisted_13 = { class: "search-section" }
const _hoisted_14 = { class: "search-box" }
const _hoisted_15 = { class: "filters-section" }
const _hoisted_16 = ["data-filter-id", "onClick"]
const _hoisted_17 = { class: "video-grid" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "video-cover" }
const _hoisted_20 = { class: "cover-frame" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "video-title" }
const _hoisted_23 = {
  key: 2,
  class: "series-page-loading"
}
const _hoisted_24 = {
  key: 3,
  class: "empty-state"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "sheet-check"
}

import logo2Image from '../assets/logo2.png'
import menuBgImage from '../assets/menu_bg.jpg'
import ParentPasswordModal from '../components/ParentPasswordModal.vue'
import LoginPromptModal from '@/components/LoginPromptModal.vue'
import VipPromptModal from '@/components/VipPromptModal.vue'
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getDictDataList } from '@/api/dict'
import { getWordSeriesPage, type WordSeries } from '@/api/course-word'
import { getAccessToken } from '@/config/axios/auth'

const PARENT_VERIFIED_STORAGE_KEY = 'tree-sprout-parent-verified'


export default /*@__PURE__*/_defineComponent({
  __name: 'flash',
  setup(__props) {

const searchKeyword = ref('')
const activeFilter = ref(1)
const activeNav = ref('')
const isFilterMenuOpen = ref(false)
const selectedVideoId = ref(null)
const filtersMainRef = ref(null)
const isTopbarScrolled = ref(false)
const route = useRoute()
const router = useRouter()
const parentPasswordModalRef = ref(null)
const isGuestUser = computed(() => getAccessToken() == null)
const isNonVipUser = computed(() =>
  !isGuestUser.value && localStorage.getItem('vipTag') === 'false'
)
const isLoginPromptOpen = ref(false)
const isVipPromptOpen = ref(false)
const categoryList = ref<any>([])
const seriesList = ref<WordSeries[]>([])
const dataTotal = ref(0)
const isLoading = ref(false)
const seriesRequestToken = ref(0)
const queryParams = ref({
  pageNo: 1,
  pageSize: 10,
  stage: route.query.stage,
  keyword: undefined as string | undefined,
  category: undefined as string | undefined,
})

const navItems = [
  { id: 'home', label: '首页', icon: 'home' },
  { id: 'history', label: '观看历史', icon: 'play-circle' },
  { id: 'favorites', label: '宝贝收藏', icon: 'heart' },
  { id: 'settings', label: '偏好设置', icon: 'cog' },
  { id: 'parent', label: '家长模式', icon: 'user-shield' },
]


const dataTotalPages = computed(() => Math.ceil(dataTotal.value / queryParams.value.pageSize))
const hasNextSeriesPage = computed(() => queryParams.value.pageNo < dataTotalPages.value)
const showSeriesSkeleton = computed(() => isLoading.value && seriesList.value.length === 0)
const isSeriesPageLoading = computed(() => isLoading.value && seriesList.value.length > 0)

const syncFilterChipIntoView = () => {
  nextTick(() => {
    const container = filtersMainRef.value
    if (!container) {
      return
    }

    const activeChip = container.querySelector(
      `button[data-filter-id="${activeFilter.value}"]`
    )
    if (!activeChip) {
      return
    }

    activeChip.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })
  })
}

const selectFilter = (filterId, categoryValue = '') => {
  activeFilter.value = filterId
  queryParams.value.category = categoryValue || undefined
  resetSeriesQuery()
  getWordSeriesList()
  syncFilterChipIntoView()
}

const toggleMoreFilters = () => {
  isFilterMenuOpen.value = !isFilterMenuOpen.value
}

const closeFilterMenu = () => {
  isFilterMenuOpen.value = false
}

const selectFilterFromMenu = (filterId, categoryValue = '') => {
  selectFilter(filterId, categoryValue)
  closeFilterMenu()
}

const handleGoBack = () => {
  if (window.history.length > 1) {
    router.back()
    return
  }

  router.push('/category')
}

const openParentPasswordModal = () => {
  parentPasswordModalRef.value?.open()
}

const openLoginPrompt = () => {
  isLoginPromptOpen.value = true
}

const goLogin = () => {
  isLoginPromptOpen.value = false
  router.push('/login')
}

const goVip = () => {
  isVipPromptOpen.value = false
  router.push('/vip')
}

const ensureCanOpenFlash = () => {
  if (isGuestUser.value) {
    openLoginPrompt()
    return false
  }

  if (isNonVipUser.value) {
    isVipPromptOpen.value = true
    return false
  }

  return true
}

const handleNavItemClick = (item) => {
  if (item.id === 'home') {
    router.push('/')
    return
  }

  if (item.id === 'parent') {
    openParentPasswordModal()
    return
  }

  if (item.id === 'settings') {
    router.push('/preference')
    return
  }

  if (item.id === 'history' || item.id === 'favorites') {
    router.push({
      path: '/history',
      query: item.id === 'favorites' ? { tab: 'favorites' } : {}
    })
  }
}

const handlePageScroll = () => {
  isTopbarScrolled.value = window.scrollY > 12
  if (isPageNearBottom()) {
    loadNextWordSeriesPage()
  }
}

const handleSearch = () => {
  queryParams.value.keyword = searchKeyword.value || undefined
  resetSeriesQuery()
  getWordSeriesList()
}

const isPageNearBottom = () => {
  const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight
  const pageHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight)

  return scrollTop + viewportHeight >= pageHeight - 120
}

const loadNextWordSeriesPage = async () => {
  if (isLoading.value || !hasNextSeriesPage.value) {
    return
  }

  queryParams.value.pageNo += 1
  await getWordSeriesList(true)
}

const resetSeriesQuery = () => {
  queryParams.value.pageNo = 1
  dataTotal.value = 0
  seriesList.value = []
}

const handleVideoClick = (video) => {
  if (!ensureCanOpenFlash()) {
    return
  }

  selectedVideoId.value = video.id
  router.push({
    path: '/word',
    query: {
      seriesId: video.id,
      title: String(video.name ?? '')
    },
  })
}

onMounted(() => {
  getCategoryList()
  getWordSeriesList()
  window.addEventListener('scroll', handlePageScroll, { passive: true })
  handlePageScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handlePageScroll)
})
const getCategoryList = async () => {
  try {
    const data = await getDictDataList('course_word_category')
    categoryList.value = [
      { id: 1, value: '', label: '全部' },
      ...(data || [])
    ]
  } catch {

  }
}
const getWordSeriesList = async (append = false) => {
  if (append && isLoading.value) {
    return
  }

  const requestToken = ++seriesRequestToken.value
  isLoading.value = true
  try {
    const data = await getWordSeriesPage(queryParams.value)
    if (requestToken !== seriesRequestToken.value) {
      return
    }

    const list = data?.list || []
    seriesList.value = append ? [...seriesList.value, ...list] : list
    dataTotal.value = data?.total || 0
  } catch {
    if (requestToken === seriesRequestToken.value && append) {
      queryParams.value.pageNo = Math.max(1, queryParams.value.pageNo - 1)
    }
  } finally {
    if (requestToken === seriesRequestToken.value) {
      isLoading.value = false
    }
  }
}


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "bg-decoration" }, [
      _createElementVNode("div", { class: "orb orb-1" }),
      _createElementVNode("div", { class: "orb orb-2" }),
      _createElementVNode("div", { class: "orb orb-3" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(logo2Image),
                alt: "",
                class: "logo2-icon"
              }, null, 8, _hoisted_7)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "brand-copy" }, [
              _createElementVNode("h1", { class: "brand-name" }, "树苗英语"),
              _createElementVNode("span", { class: "brand-subtitle" }, "TREE SAPLING")
            ], -1))
          ]),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
              return _createElementVNode("li", {
                key: item.id
              }, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(($event: any) => (handleNavItemClick(item)), ["prevent"]),
                  class: _normalizeClass(['nav-item', { active: activeNav.value === item.id }])
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: item.icon,
                    class: "nav-icon"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ], 10, _hoisted_9)
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _unref(menuBgImage),
              alt: "",
              class: "nav-menu-image"
            }, null, 8, _hoisted_11)
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_12, [
        _createElementVNode("div", {
          class: _normalizeClass(["mobile-topbar", { 'is-scrolled': isTopbarScrolled.value }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "mobile-back-btn",
            onClick: handleGoBack,
            "aria-label": "返回上一页"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "mobile-topbar-title" }, "单词闪卡", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("span", {
            class: "mobile-topbar-spacer",
            "aria-hidden": "true"
          }, null, -1))
        ], 2),
        _cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "mobile-topbar-offset",
          "aria-hidden": "true"
        }, null, -1)),
        _createElementVNode("section", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_font_awesome_icon, {
              icon: "search",
              class: "search-icon"
            }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
              type: "text",
              class: "search-input",
              placeholder: "请输入关键字搜索",
              "aria-label": "搜索单词",
              onKeyup: _withKeys(handleSearch, ["enter"])
            }, null, 544), [
              [
                _vModelText,
                searchKeyword.value,
                void 0,
                { trim: true }
              ]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "search-button",
              "aria-label": "搜索",
              title: "搜索",
              onClick: handleSearch
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("span", null, "搜索", -1)
            ]))])
          ])
        ]),
        _createElementVNode("section", _hoisted_15, [
          _createElementVNode("div", {
            ref_key: "filtersMainRef",
            ref: filtersMainRef,
            class: "filters-main"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (category) => {
              return (_openBlock(), _createElementBlock("button", {
                key: category.id,
                type: "button",
                class: _normalizeClass(["filter-chip", { active: activeFilter.value === category.id }]),
                style: _normalizeStyle({ '--filter-color': category.color || '#FF8C42' }),
                "data-filter-id": category.id,
                onClick: ($event: any) => (selectFilter(category.id, category.value))
              }, _toDisplayString(category.label), 15, _hoisted_16))
            }), 128))
          ], 512),
          _createElementVNode("button", {
            type: "button",
            class: "toggle-btn",
            onClick: toggleMoreFilters
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "chevron-down",
              class: _normalizeClass({ expanded: isFilterMenuOpen.value })
            }, null, 8, ["class"])
          ])
        ]),
        _createElementVNode("section", _hoisted_17, [
          (showSeriesSkeleton.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(queryParams.value.pageSize, (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `series-skeleton-${index}`,
                  class: "video-card series-skeleton-card"
                }, [
                  _createVNode(_component_el_skeleton, { animated: "" }, {
                    template: _withCtx(() => [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "image",
                        class: "series-skeleton-cover"
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        class: "series-skeleton-title"
                      })
                    ]),
                    _: 1
                  })
                ]))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(seriesList.value, (video) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: video.id,
                  class: _normalizeClass(["video-card", { selected: selectedVideoId.value === video.id }]),
                  onClick: ($event: any) => (handleVideoClick(video))
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("img", {
                        src: video.coverUrl,
                        alt: "",
                        class: "cover-image"
                      }, null, 8, _hoisted_21)
                    ])
                  ]),
                  _createElementVNode("h3", _hoisted_22, _toDisplayString(video.name), 1)
                ], 10, _hoisted_18))
              }), 128)),
          (isSeriesPageLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_el_skeleton, { animated: "" }, {
                  template: _withCtx(() => [
                    _createVNode(_component_el_skeleton_item, {
                      variant: "text",
                      class: "series-page-loading-line"
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!showSeriesSkeleton.value && seriesList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("p", { class: "empty-title" }, "暂无单词内容", -1),
                _createElementVNode("p", { class: "empty-desc" }, "试试更换关键词或分类筛选", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "sheet-fade" }, {
      default: _withCtx(() => [
        (isFilterMenuOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sheet-mask",
              onClick: closeFilterMenu
            }, [
              _createElementVNode("section", {
                class: "sheet-panel",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "sheet-handle" }, null, -1)),
                _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "sheet-title" }, "选择更多筛选", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (filter) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: filter.id,
                    type: "button",
                    class: _normalizeClass(["sheet-option", { active: activeFilter.value === filter.id }]),
                    style: _normalizeStyle({ '--filter-color': filter.color || '#FF8C42' }),
                    onClick: ($event: any) => (selectFilterFromMenu(filter.id, filter.value))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(filter.label), 1),
                    (activeFilter.value === filter.id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, "已选"))
                      : _createCommentVNode("", true)
                  ], 14, _hoisted_25))
                }), 128)),
                _createElementVNode("button", {
                  type: "button",
                  class: "sheet-cancel",
                  onClick: closeFilterMenu
                }, "取消")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(ParentPasswordModal, {
      ref_key: "parentPasswordModalRef",
      ref: parentPasswordModalRef
    }, null, 512),
    _createVNode(LoginPromptModal, {
      modelValue: isLoginPromptOpen.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isLoginPromptOpen).value = $event)),
      onConfirm: goLogin
    }, null, 8, ["modelValue"]),
    _createVNode(VipPromptModal, {
      modelValue: isVipPromptOpen.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isVipPromptOpen).value = $event)),
      description: "成为会员后可学习完整内容",
      onConfirm: goVip
    }, null, 8, ["modelValue"])
  ]))
}
}

})